import { render, staticRenderFns } from "./BirthdaySelect.vue?vue&type=template&id=13818551&scoped=true"
import script from "./BirthdaySelect.vue?vue&type=script&lang=ts"
export * from "./BirthdaySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13818551",
  null
  
)

export default component.exports